import React, { useEffect, useRef } from 'react';

const Carousel = () => {
  const carouselRef = useRef(null);
  const items = [
    { type: 'image', src: 'carousel/people.png' },
    { type: 'text', content: '👋 Welcome to our platform!' },
    { type: 'image', src: 'carousel/dailydigest.png' },
    { type: 'text', content: '📰 Daily Digest keeps you updated!' },
    { type: 'image', src: 'carousel/lessons.png' },
    { type: 'text', content: '📚 Learn with our interactive lessons!' },
    { type: 'image', src: 'carousel/apptracking.png' },
    { type: 'text', content: '📈 Track your applications easily!' },
    { type: 'image', src: 'carousel/alumni.png' },
    { type: 'text', content: '🤝 Connect with our alumni network!' },
  ];

  useEffect(() => {
    const scrollCarousel = () => {
      if (carouselRef.current) {
        const scrollHeight = carouselRef.current.scrollHeight;
        const clientHeight = carouselRef.current.clientHeight;
        const scrollTop = carouselRef.current.scrollTop;

        // Calculate the new scroll position
        let newScrollTop = scrollTop + 1; // Constantly scroll down by 1 pixel

        // Reset scroll position if it reaches the end
        if (scrollTop >= scrollHeight - clientHeight) {
          newScrollTop = 0; // Reset to the top
        }

        // Scroll to the new position
        carouselRef.current.scrollTo({
          top: newScrollTop,
          behavior: 'auto', // No smooth scrolling
        });
      }
    };

    const interval = setInterval(scrollCarousel, 30); // Adjust the interval for smoother scrolling

    return () => clearInterval(interval);
  }, []);

  return (
    <div ref={carouselRef} className="h-full overflow-hidden relative">
      <div className="flex flex-col">
        {/* Duplicate items for infinite scroll effect */}
        {items.concat(items).map((item, index) =>
          item.type === 'image' ? (
            <img
              key={index}
              src={item.src}
              alt={`Carousel Image ${index + 1}`}
              className="w-full h-auto mb-5 rounded-lg border border-gray-200"
            />
          ) : (
            <div
              key={index}
              className="w-full p-5 mb-5 bg-white text-center text-lg rounded-lg border-2 border-gray-200 shadow-md"
            >
              {item.content}
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default Carousel;
